import API from './jsonapi-constants'

export const CONSTANTS = {
  TOTAL: 'total',
  ATTTRIBUTE: {
    ORDER_BASE_PRICE: 'order.base.price',
    ORDER_BASE_COSTS: 'order.base.costs',
    ORDER_BASE_REBATE: 'order.base.rebate',
    ORDER_BASE_CURRENCYID: 'order.base.currencyid',
    ORDER_BASE_PRODUCT_QUANTITY: 'order.base.product.quantity',
    ORDER_BASE_COMMENT: 'order.base.comment',
    ORDER_BASE_CUSTOMERID: 'order.base.customerid',
    ORDER_BASE_STATUS: 'order.base.status',
    ORDER_BASE_CUSTOMERREF: 'order.base.customerref',
    ORDER_BASE_LANGUAGEID: 'order.base.languageid',
    ORDER_BASE_ID: 'order.base.id',
  },
  ID: {
    PAYMENT: 'payment',
    DELIVERY: 'delivery',
  },
  TYPE: {
    BASKET_PRODUCT: 'basket/product',
    BASKET_ADDRESS: 'basket/address',
  },
}

export const PATHS = {
  ORDER_BASE_PRICE: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_PRICE],
  ORDER_BASE_COSTS: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_COSTS],
  ORDER_BASE_REBATE: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_REBATE],
  ORDER_BASE_CURRENCYID: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_CURRENCYID],
  ORDER_BASE_PRODUCT_QUANTITY: [
    API.DATA,
    API.ATTRIBUTES,
    CONSTANTS.ATTTRIBUTE.ORDER_BASE_PRODUCT_QUANTITY,
  ],
  ORDER_BASE_COMMENT: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_COMMENT],
  ORDER_BASE_CUSTOMERID: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_CUSTOMERID],
  ORDER_BASE_STATUS: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_STATUS],
  ORDER_BASE_CUSTOMERREF: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_CUSTOMERREF],
  ORDER_BASE_ID: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_ID],
  BASKET_PRICE: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_PRICE],
  BASKET_COSTS: [API.DATA, API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_COSTS],
  BASKET_PRODUCT_RELATIONSHIPS: [
    API.DATA,
    API.RELATIONSHIPS,
    CONSTANTS.TYPE.BASKET_PRODUCT,
    API.DATA,
  ],
  BASKET_INCLUDED: [API.INCLUDED],
  BASKET_LINKS: [API.LINKS],
  DATA_BASKET_LINKS: [API.DATA, API.LINKS],
  PRODUCT_QUANTITY: [API.ATTRIBUTES, CONSTANTS.ATTTRIBUTE.ORDER_BASE_PRODUCT_QUANTITY],
}

export default {
  CONSTANTS,
  PATHS,
}
